import { FC } from "react";
import { faGem as faGemSolid, faKey } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Anchor, Text } from "@mantine/core";

import { SupersededRule } from "@protos/issues/v1/issues";
import { HoverTooltip } from "@shared/components";
import { useSupersededHref } from "@shared/hooks";
import { isSupersededBySecrets } from "@shared/utils";

export interface SupersededRuleInfoProps {
  supersededBy: SupersededRule[];
}

/**
 *
 * @param supersededBy: the information of the rules that we are superseded by
 * @returns optionally, a card with information about the rule being supersedable
 */
export const SupersededRuleInfo: FC<SupersededRuleInfoProps> = ({
  supersededBy,
}) => {
  const href = useSupersededHref(supersededBy);

  if (supersededBy.length === 0) {
    return null;
  }

  // if any of the superseded rules are Secrets, show Secrets info
  const isSecrets = isSupersededBySecrets(supersededBy);
  const icon = isSecrets ? faKey : faGemSolid;
  const label = isSecrets
    ? "Upgraded rule available in Secrets"
    : "Upgraded pro rule available";

  return (
    <HoverTooltip
      content={
        <Text inherit>
          {label};{" "}
          <Anchor
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            underline="always"
            c="white"
            inherit
          >
            click to see
          </Anchor>
        </Text>
      }
    >
      <Text c="blue.7" aria-label="SupersededRuleInfo" fz="xs">
        <Text inherit span mr="8px" display="inline-block">
          <FontAwesomeIcon icon={icon} />
        </Text>
        <Text inherit span>
          Upgrade available
        </Text>
      </Text>
    </HoverTooltip>
  );
};
